import { trackEventCounts } from '../trackEventCounts';
export function trackViewEventCounts(lifeCycle, viewId, onChange) {
  var _trackEventCounts = trackEventCounts({
      lifeCycle: lifeCycle,
      isChildEvent: function isChildEvent(event) {
        return event.view.id === viewId;
      },
      onChange: onChange
    }),
    stop = _trackEventCounts.stop,
    eventCounts = _trackEventCounts.eventCounts;
  return {
    stop: stop,
    eventCounts: eventCounts
  };
}